import { create } from 'zustand';
import apiClient from '../api/api';

export const useAdminNotificationsStore = create((set) => ({
  notifications: [],
  unreadCount: 0,
  isLoading: false,
  error: null,

  fetchNotifications: async () => {
    set({ isLoading: true, error: null });
    try {
      const { data } = await apiClient.get('/admin/notifications');
      set({
        notifications: Array.isArray(data.notifications) ? data.notifications : [],
        unreadCount: data.unreadCount || 0,
        isLoading: false,
      });
    } catch (error) {
      set({ isLoading: false, error: 'No se pudieron cargar las notificaciones.' });
    }
  },

  markAllAsRead: async () => {
    try {
      await apiClient.patch('/admin/notifications/read-all');
      set({ unreadCount: 0 });
    } catch (error) {
      set({ error: 'No se pudieron marcar como leidas.' });
    }
  },
}));
